import type { LucideIcon } from "lucide-react";
import { cn } from "~/lib/utils";

export type Segment<T extends string> = { value: T; label: string; detail?: string; icon?: LucideIcon };

export function SegmentedControl<T extends string>({
  label,
  value,
  segments,
  onChange,
  className,
}: {
  label: string;
  value: T;
  segments: Segment<T>[];
  onChange: (value: T) => void;
  className?: string;
}) {
  return (
    <div role="radiogroup" aria-label={label} className={cn("bg-muted grid auto-cols-fr grid-flow-col gap-1 rounded-lg p-1", className)}>
      {segments.map((segment) => {
        const on = segment.value === value;
        const Icon = segment.icon;
        return (
          <button
            key={segment.value}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(segment.value)}
            className={cn(
              "flex min-h-11 flex-col items-center justify-center rounded-md border px-2 py-1.5 text-[14px] font-medium transition-colors",
              on ? "bg-surface text-foreground border-hairline" : "text-muted-foreground hover:text-foreground border-transparent",
            )}
          >
            <span className="flex items-center gap-2">
              {Icon && <Icon className="size-4" strokeWidth={1.75} />}
              {segment.label}
            </span>
            {segment.detail && <span className="text-muted-foreground text-[12px] font-normal">{segment.detail}</span>}
          </button>
        );
      })}
    </div>
  );
}
